import { useCallback, useEffect } from 'react';

import { useAppDispatch } from '@verantos-dev/app-state-base';
import { setProgressStep } from '@verantos-dev/app-state-research-assistant';
import { type ProgressStepInfo, parseProgressStepType } from '@verantos-dev/types-common';

import { useResearchAssistantSocketContext } from '../../contexts/ResearchAssistantSocketContext';

export const useProgressStepListeners = () => {
  const dispatch = useAppDispatch();
  const { socket: currentSocket } = useResearchAssistantSocketContext();

  const progressStepHandler = useCallback(
    (data: { step: string; message?: string }) => {
      if (!data?.step) return;

      const progressStepType = parseProgressStepType(data.step);
      if (!progressStepType) {
        console.warn(`Unknown progress step type received: ${data.step}`);
        return;
      }

      const progressStepInfo: ProgressStepInfo = {
        step: progressStepType,
        message: data.message, // Include backend message if provided
      };

      dispatch(setProgressStep(progressStepInfo));
    },
    [dispatch]
  );

  useEffect(() => {
    if (currentSocket) {
      currentSocket.on('progress_step', progressStepHandler);
    }

    return () => {
      if (currentSocket) {
        currentSocket.off('progress_step', progressStepHandler);
      }
    };
  }, [progressStepHandler, currentSocket]);
};
